<template lang="">
    <div>
      <div class="">
        <!-- 公共位置 -->
        <PositionGuid :posGuids="posGuids"></PositionGuid>
        <!-- 公共位置结束 -->
        <div class="gWidth  padding bg-white">
          <div class="padding-bottom">
            <span class="right_tit">学习贯彻党的二十届三中全会精神</span>
            <div class="news_r_b" style="padding-bottom: 0;" v-if="!isDown">
              <ul>
                <li
                  class="flex flex-between "
                  v-for="item in liebiaos"
                  :key="item.id"
                >
                  <a v-if="item.link"
                  target="_blank"
                  :href=item.link
                    class="news_info"
                    style="width: 60%;"
                    >{{ item.title }}</a
                  >

                  <a v-else
                  target="_blank"
                  :href="'/#/Dxarticles/' + item.id"
                    class="news_info"
                    style="width: 60%;"
                    >{{ item.title }}</a
                  >

                  <span class="news_data">{{ item.created_at }}</span>
                </li>
              </ul>
            </div>
            <!-- #region -->
            <div class="news_r_b" style="padding-top: 15px;" v-else>
              <ul>
                <li
                  v-for="(item, indexd) in downs"
                  :key="indexd"
                  class="down"
                  style="margin-bottom: 0;"
                >
                  <span class="down_tit">{{ item.title }}</span>
                  <div class="down_des text-sm margin-top">
                    {{ item.description }}
                  </div>
                  <div
                    class="flex down_content align-center margin-top-sm padding-bootom flex-between"
                  >
                    <p
                      class="font-xs margin-right "
                      v-for="(item2, index2) in item.fj"
                      :key="index2"
                    >
                      <span class="text-blue down_link ">下载地址：</span>
                      <a :href="item2.fujian" class="cursor">{{
                        item2.fjname
                      }}</a>
                    </p>
                    <p class="flex align-center ">
                      <img
                        src="@/assets/gengxinshijian.png"
                        style="height: 14px;width: 14px;margin-right: 3px;"
                      />
                      <span class="text-blue font-xs"
                        >更新时间：{{ item.created_at }}</span
                      >
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div>
              <div
                class="page"
                v-if="
                  (!isDown && liebiaos.length > 0) || (isDown && downs.length > 0)
                "
              >
                <a href="#" @click="go(-1)" class="big_prev">上一页</a>
                <a href="#" @click="go(-1)" class="small_prev">&lt;</a>
                <a
                  href="#"
                  v-for="(item, index) in pages"
                  :key="index"
                  @click="select(item)"
                  :class="{ active: item == currentPage }"
                  >{{ item }}</a
                >
                <a href="#" @click="go(1)" class="big_prev">下一页</a>
                <a href="#" @click="go(1)" class="small_prev">&gt;</a>
              </div>
              <div class="text-center" v-else>
                暂无数据
              </div>
            </div>
            <!-- #endregion -->
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { liebiao, downlist } from "@/api/gxq";
  import PositionGuid from "../../components/PositionGuid/PositionGuid";
  export default {
    name: "Ershidasanzhong",
    components: {
      PositionGuid,
    },
    data() {
      return {
        posGuids: [
          {
            title: "学习贯彻党的二十届三中全会精神",
            link: "",
          },
        ],
        currentindex: "",
        lLm: [],
        zcjdList: [],
        currentPage: 1,
        totlePage: 45,
        liebiaos: [],
        id: 161,
        downs: [],
        isDown: false,
        down_id: "",
        isZhuanti: true, //判断是专题专栏还是文件下载，默认是专题专栏
        leftoneId: "", //左侧第一个下拉中的第一个id
        isLoading: false,
      };
    },
    mounted() {
      console.log(this.$route.query);
      this.liebiao3(this.id, this.currentPage, this.currentPage)
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        if (to.query.id && to.query.index) {
          vm.id = to.query.id;
          vm.liebiao2(to.query.id, to.query.index, 0);
        }
      });
    },
    methods: {

      liebiao3(id, indext, currentPage) {
        this.id = id;
        this.liebiao2(id, indext, currentPage);
      },
      async liebiao2(id, indext, currentPage) {
        console.log("点击了页码");
        console.log(id);

        if (currentPage) {
          // console.log('点击左侧获取这里传的currentPage实参没有任何意义，只是说明是通过点击左侧获取到的列表，这时候把当前页重置为1')
          this.currentPage = 1;
        }
        // console.log(indext)
        this.currentindex = indext;
        this.isDown = false;
        const { data } = await liebiao({
          id: 161,
          page: this.currentPage - 1,
        });
        this.liebiaos = data.data;
        this.totlePage = data.pages;
      },
      async down(id, currentPage) {
        this.leftlists.forEach((every) => {
          every.isShow = true;
        });
        this.isZhuanti = false;
        if (currentPage) {
          this.currentPage = 1;
        }
        this.down_id = id;
        this.isDown = true;
        const { data } = await downlist({
          id: this.down_id,
          page: this.currentPage - 1,
        });
        this.downs = data.data;
        this.totlePage = data.pages;
      },
      shows() {
        this.liebiao2(this.leftoneId, 0, 0);
        this.isZhuanti = true;
        this.leftlists.forEach((every) => {
          every["isShow"] = false;
        });
      },
      // 分页
      select(n) {
        // console.log(typeof(n))
        if (typeof n === "string") {
          return;
        }
        if (typeof n === this.currentPage) {
          return;
        }
        this.currentPage = n;
        if (this.isDown) {
          this.down(this.down_id);
        } else {
          this.liebiao2(this.id, this.currentindex);
        }
      },
      go(k) {
        this.currentPage += k;
        this.currentPage < 1
          ? (this.currentPage = 1)
          : this.currentPage > this.totlePage
          ? (this.currentPage = this.totlePage)
          : null;
        if (this.isDown) {
          this.down(this.down_id);
        } else {
          this.liebiao2(this.id, this.currentindex);
        }
      },
    },
    computed: {
      pages() {
        const t = this.totlePage;
        const c = this.currentPage;
        if (t <= 10) {
          return t;
        } else {
          if (c <= 5) {
            return [1, 2, 3, 4, 5, 6, 7, 8, 9, "...", t];
          }
          if (c >= t - 4) {
            return [
              1,
              "...",
              t - 8,
              t - 7,
              t - 6,
              t - 5,
              t - 4,
              t - 3,
              t - 2,
              t - 1,
              t,
            ];
          } else {
            return [
              1,
              "...",
              c - 3,
              c - 2,
              c - 1,
              c,
              c + 1,
              c + 2,
              c + 3,
              "...",
              t,
            ];
          }
        }
      },
    },
  };
  </script>
  <style src="../../../vab/styles/gaikuang/gaikuang_big.css" scoped></style>
  <style src="../../../vab/styles/gaikuang/gaikuang_mid.css" scoped></style>
  <style src="../../../vab/styles/gaikuang/gaikuang_small.css" scoped></style>
  <style scoped>
  .nav li:nth-child(5) {
    background-color: rgba(0, 140, 255, 1);
  }
  .mores_span span:nth-child(5) {
    display: block;
  }
  .down_tit {
    color: #666666;
  }
  .down_des {
    color: #999;
  }
  .font-xs {
    font-size: 12px;
  }
  .down {
    border-bottom: 1px dashed #ccc;
    padding: 10px;
  }
  </style>
